import { connect } from "react-redux";
import InspectionCreated from "./inspectionCreated";
import { bindActionCreators } from "redux";
import { inspectionCreated} from "services/redux/sales/postSaleListing/action";

const mapStateToProps = (state) => ({
    inspectionCreatedData: state.postSalesListReducer.inspectionCreatedData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        inspectionCreated
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InspectionCreated);
